import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSaveProps extends SVGProps<any> {}
export class SVGIconSave extends Component<SVGIconSaveProps> {
  render() {
    const { width = 56.47, height = 56.47, ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-save"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          d="M6,4H16.59L20,7.41V18A3,3 0 0,1 17,21H6A3,3 0 0,1 3,18V7A3,3 0 0,1 6,4M6,5A2,2 0 0,0 4,7V18A2,2 0 0,0 6,20H17A2,2 0 0,0 19,18V7.91L16.09,5H15V9L15,10H6V9L6,5M7,5V9H14V5H7M12,12A3,3 0 0,1 15,15A3,3 0 0,1 12,18A3,3 0 0,1 9,15A3,3 0 0,1 12,12M12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13Z"
          fill="#513389"
          stroke="#513389"
          strokeWidth="0.7"
          transform="scale(2.353)"
        />
      </SVG>
    );
  }
}
